export default __webpack_public_path__ + "34de612a317ee230a6123e24d29211c8.png";